import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { NodeService } from '../../Services/api-nodeservice';
import { Api } from '../../Model/api-model';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Location } from '@angular/common';
@Component({
  selector: 'app-documentation-secure',
  templateUrl: './documentation-secure.component.html'
})
export class DocumentationSecureComponent implements AfterViewInit{
    
   
  constructor(private _route: ActivatedRoute,private nodeService: NodeService,private router: Router,private httpClient: HttpClient,private _location: Location) { 

    localStorage.setItem("is_cuurent_nav_aem","y");
  }


  ngAfterViewInit(): void {
    


    this.nodeService.getFilesystem().then(
      files => this.files1 = files
      
      );
    //this.loadDataFromAEM();
    this.loadGettingStartedOverview();
  }


//    products: any = [];

    GettingStarted_Overview:any=[];
    FAQ:any=[];
    GettingStarted_CreateAnAccount:any=[];
   // apisubs:any=[];
   // prodapisubs:any=[];
    prodapp:any=[];
    sandboxapp:any=[];
    swaggerinfo:any=[];
    commonresponse:any=[];
    tempJsonString:string;

    Authentication_Overview:any=[];
    Authentication_Sandbox_APIs:any=[];
    Authentication_Producation_APIs:any=[];
    Authentication_Provider_Directory_Apis:any=[];

    files1:TreeNode[];
    selctedNode:TreeNode;
    GettingStartedOverview=false;
    GettingStartedCreateAnAccount=false;
    Creating_an_Application_ProdAp=false;
    Creating_an_Application_SandboxApp=false;
    swaggerInfo=false;
    commonResponse=false;
    authentication_overview=false;
    authentication_sandbox_apis=false;
    authentication_production_apis=false;
    authentication_provider_directory_apis=false;
    faq=false;

    currentSection = 'getting-started';

    nodeSelect(node) {
      //event.node = selected node
this.selctedNode=node;
  console.log("event node is"+this.selctedNode.data)
     if(this.selctedNode.data=='Quickstart'){
     // this.scroll('getting-started');
console.log("here we are-")
      var pageElement = document.getElementById("getting-started");
      pageElement.scrollIntoView(true);




     

     }
     if(this.selctedNode.data=='Production APIs'){
     
  //  console.log("this.prodAPISubsOffset"+this.prodAPISubsOffset)


    var pageElement = document.getElementById("prod-subscription");
     

    let offset=pageElement.offsetTop+20;

   
 

     window.scrollTo(0, offset);
    
    
    }

     if(this.selctedNode.data=='APIs Subscription'){
      
     // console.log("this.sandboxAPISubsOffset"+this.sandboxAPISubsOffset)


      
      var  pageElement = document.getElementById("apis-subscription");
      // pageElement.scrollIntoView(true);
      let offset =pageElement.offsetTop+20;
   

     window.scrollTo(0, offset);

     }

     if(this.selctedNode.data=='createanapp'){

      var pageElement = document.getElementById("sandboxapp");
     

      let offset=pageElement.offsetTop+20;
  
     
   
  
       window.scrollTo(0, offset);
      
    
     }

     if(this.selctedNode.data=='authentication_ehr_prod_apis'){

      var pageElement = document.getElementById("authentication_ehr_prod_apis_flag_div");
     

      let offset=pageElement.offsetTop+20;
  
     
   
  
       window.scrollTo(0, offset);
      
    
     }


     if(this.selctedNode.data=='FAQ'){

      var pageElement = document.getElementById("FAQ");
     

      let offset=pageElement.offsetTop+20;
  
     
   
  
       window.scrollTo(0, offset);
      
    
     }







     if(this.selctedNode.data=='prodapp'){
    
      
      var pageElement = document.getElementById("prodapp");
     

      let offset=pageElement.offsetTop+20;
  
     
   
  
       window.scrollTo(0, offset);
      


     }

  
     if(this.selctedNode.data=='swagger'){
    
      
      var pageElement = document.getElementById("swagger-info");
     

      let offset=pageElement.offsetTop+20;
  
     
   
  
       window.scrollTo(0, offset);
      


     }

     if(this.selctedNode.data=='createaccount'){
    
      
      var pageElement = document.getElementById("GettingStarted_CreateAnAccount");
     

      let offset=pageElement.offsetTop+20;
  
     
   
  
       window.scrollTo(0, offset);
      
  


     }


     if(this.selctedNode.data=='commonresponse'){
    
      
      var pageElement = document.getElementById("commonresponse-info");
     

      let offset=pageElement.offsetTop+20;
  
     
   
  
       window.scrollTo(0, offset);
      


     }


     if(this.selctedNode.data=='Authentication_Overview'){
    
      
      var pageElement = document.getElementById("Authentication_Overview");
     

      let offset=pageElement.offsetTop+20;
  
     
   
  
       window.scrollTo(0, offset);
      


     }

     if(this.selctedNode.data=='Authentication_Sandbox_APIs'){
    
      
      var pageElement = document.getElementById("Authentication_Sandbox_APIs");
     

      let offset=pageElement.offsetTop+20;
  
     
   
  
       window.scrollTo(0, offset);
      


     }

     if(this.selctedNode.data=='Authentication_Producation_APIs'){
    
      
      var pageElement = document.getElementById("Authentication_Producation_APIs");
     

      let offset=pageElement.offsetTop+20;
  
     
   
  
       window.scrollTo(0, offset);
      


     }


     if(this.selctedNode.data=='Authentication_Provider_Directory_Apis'){
    
      
      var pageElement = document.getElementById("Authentication_Provider_Directory_Apis");
     

      let offset=pageElement.offsetTop+20;
  
     
   
  
       window.scrollTo(0, offset);
      


     }

  }


  loadGettingStartedOverview(){
    //environment.getAemurl()+"/static_content/GettingStarted_Overview.json"
       //assets/Data/quickstart.json

      
       this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.get_GettingStarted_Overview()).subscribe(data =>{
        //console.log(data);
        this.GettingStartedOverview=true;
        this.GettingStarted_Overview = data;

    this.loadGettingStartedCreateAnAccount();
  
    })
  }

  loadGettingStartedCreateAnAccount(){
    //environment.getAemurl()+"/static_content/GettingStarted_CreateAnAccount.json"
       //assets/Data/quickstart.json
       this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.GettingStarted_CreateAnAccount()).subscribe(data =>{
        //console.log(data);
        this.GettingStartedCreateAnAccount=true;
        this.GettingStarted_CreateAnAccount = data;

        this.loadCreatingAnApplicationSandboxApp();
 
      })
  }

  loadCreatingAnApplicationSandboxApp(){
    //environment.getAemurl()+"/static_content/Creating_an_Application_SandboxApp.json"
       //assets/Data/createapp.json
       this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.Creating_an_Application_SandboxApp()).subscribe(data =>{
        //console.log(data);
        this.Creating_an_Application_SandboxApp=true;
        this.tempJsonString = JSON.stringify(data);
        var re = /content\/dam\/developerportal_aetna_com/gi; 
        this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');
 
        this.sandboxapp=JSON.parse(this.tempJsonString);

        this.loadCreatingAnApplicationProdApp();

      })
  }

  loadCreatingAnApplicationProdApp(){
     //environment.getAemurl()+"/static_content/Creating_an_Application_ProdApp.json"
       //assets/Data/createprodapp.json
       this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.Creating_an_Application_ProdApp()).subscribe(data =>{
        //console.log(data);
        this.Creating_an_Application_ProdAp=true;
        this.tempJsonString = JSON.stringify(data);
        var re = /content\/dam\/developerportal_aetna_com/gi; 
        this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');
 
        this.prodapp=JSON.parse(this.tempJsonString);
 
          this.loadAuthenticationOverview();
      })
  }

  loadAuthenticationOverview(){
     //environment.getAemurl()+"/static_content/authentication_overview.json"
            //assets/Data/commonresponse.json
            this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.authentication_overview()).subscribe(data =>{
              //console.log(data);
              this.authentication_overview=true;
              this.tempJsonString = JSON.stringify(data);
              var re = /content\/dam\/developerportal_aetna_com/gi; 
              this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');
       
              this.Authentication_Overview=JSON.parse(this.tempJsonString);

              this.loadAuthenticationSandboxApis();
      
            })
  }

  loadAuthenticationSandboxApis(){
    //environment.getAemurl()+"/static_content/authentication_sandbox_apis.json"
            //assets/Data/commonresponse.json
            this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.authentication_sandbox_apis()).subscribe(data =>{
              //console.log(data);
              this.authentication_sandbox_apis=true;
              this.tempJsonString = JSON.stringify(data);
              var re = /content\/dam\/developerportal_aetna_com/gi; 
              this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');
       
              this.Authentication_Sandbox_APIs=JSON.parse(this.tempJsonString);

              this.loadAuthenticationProductionApis();
      
            })
  }

  loadAuthenticationProductionApis(){
     //environment.getAemurl()+"/static_content/authentication_production_apis.json"
            //assets/Data/commonresponse.json
            this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.authentication_production_apis()).subscribe(data =>{
              //console.log(data);
              this.authentication_production_apis=true;
              this.tempJsonString = JSON.stringify(data);
              var re = /content\/dam\/developerportal_aetna_com/gi; 
              this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');
       
              this.Authentication_Producation_APIs=JSON.parse(this.tempJsonString);

              this.loadAuthenticationProviderDirectoryApis();
      
            })
  }

  loadAuthenticationProviderDirectoryApis(){
            //environment.getAemurl()+"/static_content/authentication_provider_directory_apis.json"
             //assets/Data/commonresponse.json
             this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.authentication_provider_directory_apis()).subscribe(data =>{
              //console.log(data);
              this.authentication_provider_directory_apis=true;
              this.tempJsonString = JSON.stringify(data);
              var re = /content\/dam\/developerportal_aetna_com/gi; 
              this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');
       
              this.Authentication_Provider_Directory_Apis=JSON.parse(this.tempJsonString);

              this.loadEHRProdAPIsAuthentication();
      
            })

  }

authentication_ehr_prod_apis_flag=false;
authentication_ehr_prod_apis_data:any=[];


  loadEHRProdAPIsAuthentication(){
    //environment.getAemurl()+"/static_content/"+environment.authentication_ehr_prod_apis()
     //http://localhost:4200/assets/Data/authentication_ehr_prod_apis.json
     this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.authentication_ehr_prod_apis()).subscribe(data =>{
      //console.log(data);
      this.authentication_ehr_prod_apis_flag=true;
      this.tempJsonString = JSON.stringify(data);
      var re = /content\/dam\/developerportal_aetna_com/gi; 
      this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');

      this.authentication_ehr_prod_apis_data=JSON.parse(this.tempJsonString);

      this.loadSwaggersInfo();

    })

}





  loadSwaggersInfo(){
         //environment.getAemurl()+"/static_content/swaggerinfo.json"
          //assets/Data/swaggerinfo.json
          this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.swaggerinfo()).subscribe(data =>{
            //console.log(data);
            this.swaggerInfo=true
            this.tempJsonString = JSON.stringify(data);
            var re = /content\/dam\/developerportal_aetna_com/gi; 
            this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');
     
            this.swaggerinfo=JSON.parse(this.tempJsonString);

            this.loadCommonResponse();
 
          })
  }

  loadCommonResponse(){
     //environment.getAemurl()+"/static_content/commonresponse.json"
            //assets/Data/commonresponse.json
            this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.commonresponse()).subscribe(data =>{
              //console.log(data);
              this.commonResponse=true;
              this.tempJsonString = JSON.stringify(data);
              var re = /content\/dam\/developerportal_aetna_com/gi; 
              this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');
       
              this.commonresponse=JSON.parse(this.tempJsonString);

              this.loadFAQ();
      
            })
  }

  loadFAQ(){
    //environment.getAemurl()+"/static_content/faq.json"
             //assets/Data/commonresponse.json
             this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.faq()).subscribe(data =>{
              //console.log(data);
              this.faq=true;
              this.tempJsonString = JSON.stringify(data);
              var re = /content\/dam\/developerportal_aetna_com/gi; 
              this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');
       
              this.FAQ=JSON.parse(this.tempJsonString);
      
            })
  }
 


  /* loadDataFromAEM(){
    
     





       //environment.getAemurl()+"/static_content/GettingStarted_Overview.json"
       //assets/Data/quickstart.json
       this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.get_GettingStarted_Overview()).subscribe(data =>{
        //console.log(data);
        this.GettingStartedOverview=true;
        this.GettingStarted_Overview = data;
  
       
       
      })


       
       //environment.getAemurl()+"/static_content/GettingStarted_CreateAnAccount.json"
       //assets/Data/quickstart.json
       this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.GettingStarted_CreateAnAccount()).subscribe(data =>{
        //console.log(data);
        this.GettingStartedCreateAnAccount=true;
        this.GettingStarted_CreateAnAccount = data;
  
       
       
      })







            

   
     
       //environment.getAemurl()+"/static_content/Creating_an_Application_ProdApp.json"
       //assets/Data/createprodapp.json
      this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.Creating_an_Application_ProdApp()).subscribe(data =>{
        //console.log(data);
        this.Creating_an_Application_ProdAp=true;
        this.tempJsonString = JSON.stringify(data);
        var re = /content\/dam\/developerportal_aetna_com/gi; 
        this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');
 
        this.prodapp=JSON.parse(this.tempJsonString);
 
        
        
       
  
       
       
      })
       //environment.getAemurl()+"/static_content/Creating_an_Application_SandboxApp.json"
       //assets/Data/createapp.json
      this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.Creating_an_Application_SandboxApp()).subscribe(data =>{
        //console.log(data);
        this.Creating_an_Application_SandboxApp=true;
        this.tempJsonString = JSON.stringify(data);
        var re = /content\/dam\/developerportal_aetna_com/gi; 
        this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');
 
        this.sandboxapp=JSON.parse(this.tempJsonString);


      
  
       
       
      })


      
           //environment.getAemurl()+"/static_content/swaggerinfo.json"
          //assets/Data/swaggerinfo.json
      this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.swaggerinfo()).subscribe(data =>{
        //console.log(data);
        this.swaggerInfo=true
        this.tempJsonString = JSON.stringify(data);
        var re = /content\/dam\/developerportal_aetna_com/gi; 
        this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');
 
        this.swaggerinfo=JSON.parse(this.tempJsonString);


      
  
       
       
      })

           //environment.getAemurl()+"/static_content/commonresponse.json"
            //assets/Data/commonresponse.json
            this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.commonresponse()).subscribe(data =>{
              //console.log(data);
              this.commonResponse=true;
              this.tempJsonString = JSON.stringify(data);
              var re = /content\/dam\/developerportal_aetna_com/gi; 
              this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');
       
              this.commonresponse=JSON.parse(this.tempJsonString);
      
            })


             //environment.getAemurl()+"/static_content/authentication_overview.json"
            //assets/Data/commonresponse.json
            this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.authentication_overview()).subscribe(data =>{
              //console.log(data);
              this.authentication_overview=true;
              this.tempJsonString = JSON.stringify(data);
              var re = /content\/dam\/developerportal_aetna_com/gi; 
              this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');
       
              this.Authentication_Overview=JSON.parse(this.tempJsonString);
      
            })


           //environment.getAemurl()+"/static_content/authentication_sandbox_apis.json"
            //assets/Data/commonresponse.json
            this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.authentication_sandbox_apis()).subscribe(data =>{
              //console.log(data);
              this.authentication_sandbox_apis=true;
              this.tempJsonString = JSON.stringify(data);
              var re = /content\/dam\/developerportal_aetna_com/gi; 
              this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');
       
              this.Authentication_Sandbox_APIs=JSON.parse(this.tempJsonString);
      
            })


             //environment.getAemurl()+"/static_content/authentication_production_apis.json"
            //assets/Data/commonresponse.json
            this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.authentication_production_apis()).subscribe(data =>{
              //console.log(data);
              this.authentication_production_apis=true;
              this.tempJsonString = JSON.stringify(data);
              var re = /content\/dam\/developerportal_aetna_com/gi; 
              this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');
       
              this.Authentication_Producation_APIs=JSON.parse(this.tempJsonString);
      
            })


             //environment.getAemurl()+"/static_content/authentication_provider_directory_apis.json"
             //assets/Data/commonresponse.json
            this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.authentication_provider_directory_apis()).subscribe(data =>{
              //console.log(data);
              this.authentication_provider_directory_apis=true;
              this.tempJsonString = JSON.stringify(data);
              var re = /content\/dam\/developerportal_aetna_com/gi; 
              this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');
       
              this.Authentication_Provider_Directory_Apis=JSON.parse(this.tempJsonString);
      
            })



            //environment.getAemurl()+"/static_content/faq.json"
             //assets/Data/commonresponse.json
             this.httpClient.get(environment.getAemurl()+"/static_content/"+environment.faq()).subscribe(data =>{
              //console.log(data);
              this.faq=true;
              this.tempJsonString = JSON.stringify(data);
              var re = /content\/dam\/developerportal_aetna_com/gi; 
              this.tempJsonString=this.tempJsonString.replace(re,'managedcontent');
       
              this.FAQ=JSON.parse(this.tempJsonString);
      
            })







    }//end of ngoninit */


  
  
    ngAfterViewChecked(){
      document.querySelectorAll('h1')
      .forEach((input) => {
        var att = document.createAttribute("class");       // Create a "class" attribute
        att.value = "aem-h1";                           // Set the value of the class attribute
        input.setAttributeNode(att); 

         }
       
      ); //end for h1

      document.querySelectorAll('li')
      .forEach((input) => {
        var att = document.createAttribute("class");       // Create a "class" attribute
        att.value = "aem-li";                           // Set the value of the class attribute
        input.setAttributeNode(att); 

         }
       
      ); //end for Li


      document.querySelectorAll('h2')
      .forEach((input) => {
        var att = document.createAttribute("class");       // Create a "class" attribute
        att.value = "aem-h2";                           // Set the value of the class attribute
        input.setAttributeNode(att); 

         }
       
      ); //end for h2

      document.querySelectorAll('h3')
      .forEach((input) => {
        var att = document.createAttribute("class");       // Create a "class" attribute
        att.value = "aem-h3";                           // Set the value of the class attribute
        input.setAttributeNode(att); 

         }
       
      ); //end for h3


      document.querySelectorAll('table')
      .forEach((input) => {
        var att = document.createAttribute("class");       // Create a "class" attribute
        att.value = "table table-success table-hover white-table";                           // Set the value of the class attribute
        input.setAttributeNode(att); 

         }
       
      ); //end for h3


      document.querySelectorAll('b')
      .forEach((input) => {
        var att = document.createAttribute("class");       // Create a "class" attribute
        att.value = "aem-bp";                           // Set the value of the class attribute
        input.setAttributeNode(att); 

         }
       
      ); //end for b


      document.querySelectorAll('img')
      .forEach((input) => {
        var att = document.createAttribute("class");       // Create a "class" attribute
        att.value = "aem-img";                           // Set the value of the class attribute
        input.setAttributeNode(att); 

         }
       
      ); //end for img





     


  }

  
  }